<!--添加故障报备-->
<template>
    <div class="faultDetail">
        <van-nav-bar
            title="查看故障"
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <van-form ref="faultDetail">
            <h2 class="title baseInfo-title">
                <i class="iconfont icondanjubianhao"></i>基本信息
            </h2>
            <van-field
                v-model="form.accident"
                label="车辆位置"
                :left-icon="require('@/assets/images/icons/icon_gy_2.png')"
                input-align="right"
                readonly
                @click="viewCarPosition"
            ></van-field>
            <!--            @click="viewCarPosition"-->

            <van-field
                v-model="form.licensenumber"
                label="车牌号"
                :left-icon="require('@/assets/images/icons/icon_gy_9.png')"
                input-align="right"
                readonly
            ></van-field>
            <van-field
                v-model="form.carnumber"
                label="车小号"
                :left-icon="require('@/assets/images/icons/icon_18.png')"
                input-align="right"
                readonly
            ></van-field>
            <van-field
                v-model="form.driver"
                label="驾驶员"
                :left-icon="require('@/assets/images/icons/icon_3.png')"
                input-align="right"
                readonly
            ></van-field>
            <van-field
                v-model="form.phone"
                label="联系电话"
                :left-icon="require('@/assets/images/icons/icon_4.png')"
                input-align="right"
                readonly
            ></van-field>
            <van-field
                v-model="form.reportedtime"
                label="时间"
                :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                input-align="right"
                readonly
            ></van-field>
            <h2 class="title">
                <i class="iconfont icondanjubianhao"></i>故障类型
            </h2>
            <div class="accent-type">
                <div class="type-item active">
                    {{ accentTypes[form.accidenttype] }}
                </div>
                <div class="type-item active2" v-if="form.accidenttype===3">
                    {{ traffictypes[form.traffictype] }}
                </div>
            </div>
            <h2 class="title">
                <i class="iconfont icondanjubianhao"></i>影像资料
            </h2>
            <div class="video-img-list">
                <van-uploader
                    v-model="fileList"
                    preview-image
                    preview-full-image
                    multiple
                    :max-count="10"
                    :max-size="10000 * 1024"
                    :deletable="false"
                    :show-upload="false"
                ></van-uploader>
            </div>
            <h2 class="title">
                <i class="iconfont iconpingjia"></i>描述
            </h2>
            <div class="txt-box">
                <div class="result-txt">
                    {{ form.describe }}
                </div>
            </div>
            <h2 class="title">
                <i class="iconfont icondingdanqueren"></i>处理结果
            </h2>
            <div class="txt-box">
                <div class="result-txt" v-if="form.result">
                    {{ form.result }}
                </div>
            </div>
        </van-form>
    </div>
</template>

<script>
export default {
    name: 'fault-form',
    data() {
        return {
            form: {
                Id: '', // 故障数据id
                driver: '',
                phone: '',
                licensenumber: '', // 车牌号
                accidenttype: 0, // 1车辆故障、2车辆超载、3交通事故、4其他
                traffictype: 0, // 1对方责任、2我方责任 3双方责任
                reportedtime: '', // 报备时间
                accident: '', // 事故地
                describe: '', // 描述
                result: '', // 处理结果
                lastresult: '', // 最后处理结果
                status: 0, // 处理状态 0：新上报 1：未处理 2： 已处理 3: 已办结
                station: '', // 车辆隶属场站
                company: '', // 所属公司
                motorcade_id: '', // 车队id
                userid: '', // 司机id
                is_publish: 0, // 是否发布

                filepath: '', // 文件
                carnumber: '', // 车小号
                longlat: '', // 经纬度
            },
            fileList: [],
            accentTypes: {
                1: '车辆故障',
                2: '车辆超载',
                3: '交通事故',
                4: '其他',
            },
            traffictypes: {
                1: '我方责任',
                2: '对方责任',
                3: '双方责任',
            },
        };
    },
    created() {
        this.initData();
    },
    methods: {
        initData() {
            this.form.Id = this.$route.query.Id || '';
            this.getDataInfo();
        },
        // 获取详情 编辑时
        getDataInfo() {
            this.$axios.get('/interfaceApi/logistics/car_feedback/get_carfeedbackbyid?id=' + this.form.Id)
                .then(res => {
                    this.form = res;
                    if (res.filepath) {
                        const fileIds = res.filepath.split(',');
                        fileIds.forEach(fileId => {
                            this.getFileDetailFun(fileId);
                        });
                    }
                });
        },
        // 获取文件下载预览地址
        getFileDetailFun(item) {
            const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item}/download`;
            this.fileList.push({
                url: url,
                id: item,
                isImage: true,
            });
        },
        // 查看车辆位置
        viewCarPosition() {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/carPosition',
                query: {
                    longlat: this.form.longlat,
                },
            },);
        },
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="stylus" scoped>
    .faultDetail{
        box-sizing border-box;
        width 100%;
        height 100%;
        padding-bottom 70rpx;
        .van-form{
            width 100%;
            height 100%;
            overflow-y auto
            >>> .van-field__error-message{
                display none;
            }
            .title{
                display flex
                align-items center
                height 48rpx;
                padding-left 13rpx;
                font-size 18rpx;
                color #3495FB
                .iconfont{
                    margin-right 7rpx;
                }
                &.baseInfo-title{
                    border-bottom: 1px solid #ebedf0;
                }
            }
            .accent-type{
                border-bottom: 1px solid #ebedf0;
                padding-left 14rpx;
                display flex
                flex-wrap wrap
                .type-item{
                    width: 80rpx;
                    height: 30rpx;
                    background: #F1F1F1;
                    border-radius: 4rpx;
                    display flex
                    justify-content center
                    align-items center
                    flex-direction column;
                    font-size 14rpx;
                    color #666;
                    margin 0 9rpx 9rpx 0;
                    position relative
                    &.active{
                        background #FEE5E5;
                        color #E60000
                    }
                    &.active2{
                        background #FFFADD;
                        color #FF6600
                    }
                }
                .popover-contain{
                    width 100%;
                    >>> .van-popover__content{
                        border-radius 0;
                    }
                    .responsibility{
                        display flex
                        padding 15rpx 6rpx 6rpx 15rpx;
                        background: #FFFFFF;
                        box-shadow: 0px 2rpx 4rpx 0px rgba(0, 0, 0, 0.2);
                    }
                }
            }
            .video-img-list{
                padding-left 16rpx;
                padding-bottom 10rpx;
                border-bottom: 1px solid #ebedf0;
            }
            .txt-box{
                padding 0 14rpx;
                width: 100%;
                .result-txt{
                    width 100%;
                    background: #F8F8F8;
                    border-radius: 4rpx;
                    color #333333
                    font-size 14rpx;
                    padding 15rpx;
                }
            }
        }
        .footer{
            position: fixed;
            left 0;
            bottom 0;
            width 100%;
            padding 15rpx;
            background #fff;
            .submit-btn{
                width: 100%;
                height: 40rpx;
                background: #D6000F;
                border-radius: 4rpx;
                display flex
                justify-content center
                align-items center
                color #fff;
                font-size 16rpx;
            }
        }
    }
</style>
